import { ChangeDetectionStrategy, Component } from '@angular/core';
import {ActivatedRoute, RouterLink} from "@angular/router";
import {ButtonDirective} from "primeng/button";

@Component({
  selector: 'homey-waitlist-success-page',
  imports: [
    ButtonDirective,
    RouterLink
  ],
  templateUrl: './waitlist-success-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WaitlistSuccessPageComponent {
  constructor(private readonly activatedRoute: ActivatedRoute) {
  }

  protected readonly email = this.activatedRoute.snapshot.queryParams['email'];
}
